export const responsiveSliderSettings = [
  { breakpoint: 768, settings: { slidesToShow: 4, slidesToScroll: 2 } },
  { breakpoint: 400, settings: { slidesToShow: 2, slidesToScroll: 1 } },
  { breakpoint: 600, settings: { slidesToShow: 3, slidesToScroll: 1 } },
];



// WEBPACK FOOTER //
// ./src/utilities/ui.js